import { PageRoute } from 'src/routes/routes-behind-login/page-route'

export const queryParamsFilters =
  '?loadLast=loadLast&columns=Open+Date&columns=Open+Port&columns=L3C&columns=Comments&ShowBallastDuplicates=Show+Ballast+Duplicates&sort=Open+Date&order=asc'

export function useCharteringSubPages() {
  return [
    {
      title: 'Position List',
      link: `${PageRoute.POSITION_LIST}${queryParamsFilters}`,
    },
    {
      title: 'Cargo List',
      link: PageRoute.CARGO_LIST,
    },
    {
      title: 'Check before you fix',
      link: PageRoute.PRE_FIX,
    },
    {
      title: 'Recap Hub',
      link: PageRoute.RECAP_HUB,
    },
    {
      title: 'Cargo Statistics',
      link: PageRoute.CARGO_STATISTICS,
    },
    {
      title: 'Exposure',
      link: PageRoute.EXPOSURE,
    },
    {
      title: 'Map',
      link: `${PageRoute.MAP}${queryParamsFilters}`,
    },
    {
      title: 'Clear',
      link: PageRoute.CLEAR,
    },
  ]
}
